<template>
  <div class="trip-route" @click="selectRoute">
    <div>
      <h2>{{ route.summary }} </h2>
      <p><span v-if="legs == 1">{{ duration }} &middot; {{ distance }} &middot;</span> {{ steps.length }} steps</p>
    </div>

    <Risk :score="score.toFixed(2)" v-if="score" />

  </div>
</template>

<script>
import Risk from './Risk';

export default {
  components: { Risk },
  props: [ 'route' ],
  async mounted() {
    this.score = await this.$store.dispatch('getModelForRoute', this.route);
  },
  data() {
    return { score: null }
  },
  methods: {
    selectRoute() {
      this.$store.commit('setItem', { key: 'route', value: this.route });
    }
  },
  computed: {
    legs() {
      return this.route.legs.length;
    },
    duration() {
      if(this.route.legs.length) {
        return this.route.legs[0].duration.text;
      }

      return '';
    },
    distance() {
      if(this.route.legs.length) {
        return this.route.legs[0].distance.text;
      }

      return '';
    },
    steps() {
      return this.route.legs[0].steps;
    }
  }
}
</script>

<style>
.trip-route {
  transition: all 200ms;
  border-radius: 6px;
  background: #fff;
  margin: 5px 0;
  padding: 1rem;
  user-select: none;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.trip-route:hover {
  background-color: #eee;
}

</style>
